
import { BrowserRouter } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Project from "./components/Projects/Project";
import Landingpage from "./components/LandingPage/Landingpage";
import Contact from "./components/contact/Contact";

import Skills from './components/Skills/Skill'
import Education from "./components/Education/Education";


function App() {
  // const [darkMode, setDarkMode] = useState(false);

  // const toggleDarkMode = () => {

  //   setDarkMode(!darkMode);
  //   if(!darkMode){
  //     setDarkMode(true)
  // };
  // if(darkMode){
  //   setDarkMode(false)
  // };
  


  
  return (
    <>
    <div >


    <BrowserRouter>
    <Navbar />
    <Landingpage />
    <Skills/>
    <Project/>
    <Education/>
    <Contact/>

    </BrowserRouter>
    </div>



    </>
  )
  }

export default App;
